import { SEARCH_QUERY } from "../../../../Utils/AllPagesQuriesAndMutations";

export let data = [
  {
    id: Math.random() * 10,
    name: "Load_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Loading_Name",
        label: "From Location",
        masterName: "GoogleLocation",
        type: "GoogleSearch",
        notSearchable: true,
        dropdowncontent: SEARCH_QUERY,
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "currentLocationRadius",
        label: "From Radius",
        type: "inputdrop",
        dropdowncontent: [50, 75, 100, 150, 200, 300],
        // isRequired: true,
        notSearchable: true,
      },
      {
        id: Math.random() * 10,
        name: "Unloading_Name",
        label: "To Location",
        masterName: "GoogleLocation",
        type: "GoogleSearch",
        notSearchable: true,
        dropdowncontent: SEARCH_QUERY,
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "destLocationRadius",
        label: "To Radius",
        type: "inputdrop",
        dropdowncontent: [50, 75, 100, 150, 200, 300],
        // isRequired: true,
        notSearchable: true,
      },
    ],
  },
  // {
  //   id: Math.random() * 10,
  //   name: "Load_Details",
  //   label: "Load Details",
  //   fields: [
  //     {
  //       id: Math.random() * 10,
  //       name: "Vehicle_Length",
  //       label: "Vehicle Length (Ft)",
  //       type: "number",
  //       isRequired: true,
  //     },
  //     {
  //       id: Math.random() * 10,
  //       name: "Payload_Capacity",
  //       label: "Payload Capacity (Mt)",
  //       type: "number",
  //       isRequired: true,
  //     },
  //   ],
  // },
  {
    id: Math.random() * 10,
    name: "Vehicle_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Vehicle_Category",
        type: "inputdrop",
        dropdowncontent: [
          "Trailer Dala Body",
          "Trailer Flat Bed ",
          "Open Body Truck",
          "Container",
          "Tanker",
          "Tipper",
          "Bulker",
          "Dumper",
        ],
        min: 1,
        max: Infinity,
        notSearchable: true,
      },
    ],
  },
];
